/*
 * Entry point types.
 */

export enum EntryPointTypesEnum {
  CONVERSATION_LINK_DROPDOWN = 'CONVERSATION_LINK_DROPDOWN',
  MESSAGE_MORE_DROPDOWN = 'MESSAGE_MORE_DROPDOWN',
  SIDE_PANEL = 'SIDE_PANEL',
}

/*
 * Entry point template.
 */

export interface EntryPointTemplate {
  id: string;
  type: EntryPointTypesEnum;
}
